import { BOLD_BUTTON, FONT_SIZE_SELECT, FORE_COLOR, INDENT_BUTTON, ITALIC_BUTTON, ORDERED_LIST_BUTTON, OUTDENT_BUTTON, REDO_BUTTON, REMOVE_FORMAT_BUTTON, SEPARATOR, SUBSCRIPT_BUTTON, SUPERSCRIPT_BUTTON, UNDERLINE_BUTTON, UNDO_BUTTON, UNORDERED_LIST_BUTTON } from "ngx-simple-text-editor";
import { environment } from "src/environments/environment";


export const baseUrl = environment.baseAppUrl;

export const mngAppBaseUrl = environment.mngAppBaseUrl;

export const mngAppAuthUrl = environment.manageAuthUrl;

export const mngAPIUrlAppender = '/mngAPIUrl';

export const ApiUrlTexts = {
    auditLogs: 'audit-log/logs',
    wfLogs: 'workflow-execution/instances'
}

export const APIUrls = {
    baseUrl: baseUrl,
    authenticatePartner: baseUrl + 'oauth/partner/',
    loginPartner: baseUrl + 'oauth/partner?short-name=',
    authorisation: baseUrl + 'oauth/authorisation',
    partnerApps: baseUrl + 'partner/',
    customerApps: baseUrl + 'customer/',
    generalApps: baseUrl + 'app/'
}

export const MNGUrls = {
    registerPartner: baseUrl + 'manage/partner',
    // validateInviteCode: mngAppBaseUrl + 'manage/invite-code/validate?invite-code=',
    appBase: mngAppBaseUrl + 'manage/app',
    appBaseWithToken: mngAppBaseUrl + 'manage/app' + mngAPIUrlAppender,
    listApps: mngAppBaseUrl + 'manage/app/apps',
    listAppsManage: mngAppBaseUrl + 'manage/app/apps' + mngAPIUrlAppender,
    mngAppAuthUrl: mngAppBaseUrl + 'manage/oauth/login' + mngAPIUrlAppender,
    mngAppAuthToken: mngAppBaseUrl + 'manage/oauth/token' + mngAPIUrlAppender,
    mngUserInfo: mngAppBaseUrl + 'manage/userinfo' + mngAPIUrlAppender,
    createPartnerInvite: mngAppBaseUrl + 'manage/invite-code' + mngAPIUrlAppender,
    partnerBase: mngAppBaseUrl + 'manage/partner/' + mngAPIUrlAppender,
    partnerBaseA: mngAppBaseUrl + 'manage/partner' + mngAPIUrlAppender,
    metadata: mngAppBaseUrl + 'manage/metadata',
    getPartnersList: mngAppBaseUrl + 'manage/partner/partners' + mngAPIUrlAppender,
    getVendorsList: mngAppBaseUrl + 'manage/vendor/vendors' + mngAPIUrlAppender,
    vendorBase: mngAppBaseUrl + 'manage/vendor' + mngAPIUrlAppender,
    vendorAppBase: mngAppBaseUrl + 'manage/app' + mngAPIUrlAppender,
    manageAuditLogs: mngAppBaseUrl + 'manage/' + ApiUrlTexts.auditLogs + mngAPIUrlAppender,
    manageWfLogs: mngAppBaseUrl + 'manage/' + ApiUrlTexts.wfLogs + mngAPIUrlAppender,
    appStates: mngAppBaseUrl + 'manage/partner-app/apps' + mngAPIUrlAppender,
    appDocument: mngAppBaseUrl + 'manage/app-document/' + mngAPIUrlAppender,
    workflowDefinitionAppBase: mngAppBaseUrl + 'manage/app' + mngAPIUrlAppender,
    requestInfo: 'request-info'
}

export const MNGAuthUrls = {
    logoutNormal: mngAppAuthUrl + 'logout',
    logout: mngAppAuthUrl + 'logout?federated'
}

export const UserRoles = {
    superuser: 'Super User',
    reseller: 'Reseller',
    officemanager: 'Office Manager',
}

export const AppSide = {
    manageSide: 'manageSide',
    storeSide: 'storeSide'
}

export const CommonTexts = {
    goToDetail: 'Go To Detail',
    noAppsFound: 'No Apps Found',
    noAppsFoundForCategory: 'No apps found for selected category',
    noCustomFieldsPresent: 'No Custom Fields Present',
    noTechDetails: 'No Technical Details Found',
    pleaseLoginToView: 'Please login to view.'
}

export const headerTexts = {
    categories: 'CATEGORIES',
    products: 'PRODUCTS',
    partnerReg: 'CSP Registration',
    partnerAppEnableWh: 'PARTNER APP ENABLE',
    customerAppEnableWh: 'CUSTOMER APP ENABLE',
    userAppEnableWh: 'USER APP ENABLE'
}

export const PopupHeaderTexts = {
    enableDomains: 'Enabled Domains',
    enableUsers: 'Enabled Users'
}

export const errorMsgs = {
    required: 'Required',
    invalidFormat: 'Invalid format',
    enterValidJosn: 'Enter a valid JSON'
}

export const AlertTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warning: 'warning',
    question: 'question',
}

export const AlertTypeClasses = {
    success: 'alert-success',
    error: 'alert-error',
    info: 'alert-info',
    warning: 'alert-warning',
    light: 'alert-light',
    dark: 'alert-dark'
}


export const AlertBtnText = {
    ok: 'Ok',
    yes: 'Yes',
    cancel: 'Cancel',
    update: 'Update',
    review: 'Review'
}

export const AlertTitles = {
    successTitle: 'Success',
    areYouSureTitle: 'Are you sure?',
    deletedTitle: 'Deleted',
    review: 'Review',
    accessDeniedOrSessionExp: 'Access Denied OR</br>Session Expired',
    reviewWebhookUpdateMsg: 'This app has webhooks enabled. Do you want to review?',
    nowebhookspresent: 'No webhooks present',
    emailSentSuccessFully: 'Email sent successfully'
}

export const errorMsgsPopup = {
    tryLoginAgain: 'Please try log in again',
    revokeCheckSuHeading: 'Cannot disable the app as it is in use. Do you want to see the list of enabled domains?',
    revokeCheckOmHeading: 'Cannot disable the app as it is in use. Do you want to see the list of enabled users?',
    noChanges: 'No changes added',
    somethingWentWrong: 'Something went wrong',
    selectLeastOneField: 'Please select at least one field',
    uploadFailed: 'Upload failed',
    deleteFailed: 'Delete failed',
    noPartnersEnabledApp: 'No csp(s) have enabled this application',
    codeSentTo: 'Invite code sent to',
    promotedAppsFull: 'The maximum number of promoted apps has been reached. Please remove an existing promoted app before adding a new one.'
}

// Maximum number of apps that can be promoted (spotlight) at once.
export const PromotedAppsLimit = 9;

export const categoriesArr = [
    'Messaging', 'Analytics', 'CRM', 'Automation', 'Recording', 'Auto Dealers'
]

export const RegExPatterns = {
    urlWithoutHTTP: '^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$',
    email: /^\w+([\.\-]?\w+)*@\w+([\.\-]?\w+)*(\.\w{2,3})+$/,
    nonWhiteSpaces: /^\S*$/,
    phoneNumber: /^[\+]?[\(]?[0-9]{3}[\)]?[\-\s\.]?[0-9]{3}[\-\s\.]?[0-9]{4,6}$/, // (123) 456-7890 (123)456-7890 123-456-7890 123.456.7890 1234567890 +31636363634 075-63546725
    phoneNumberE: /^\+[1-9]\d{1,14}$/, // E.164
    phoneNumberEUS: /^[\+]?[\(]?[0-9]{3}[\)]?[\-\s\.]?[0-9]{3}[\-\s\.]?[0-9]{4,6}$|^\+[1-9]\d{1,14}$/, // E.164 + US numbers (phoneNumber + phoneNumberE)
    // phoneNumber: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ // 123-456-7890 (123) 456-7890 123 456 7890 123.456.7890 +91 (123) 456-7890
    urlRegex: /^(https?:\/\/)([\w\-]+\.)+[\w\-]+(\/[\w\-]*)*$/,
    urlRegexWithPort: /^(https?:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
    urlRegexWithPortCapitalLettersAllowed: /^(https?:\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
    nameWithspaceHyphensApostrophesLetters: /^[a-zA-Z\s'\-]+$/, // Allows spaces, hyphens, apostrophes, and letters
    nameWithspaceHyphensApostrophesLettersNum: /^[a-zA-Z0-9\s'\-]+$/, // Allows spaces, hyphens, apostrophes, letters and numbers
    regexPositiveInteger: /^\d+$/

}

export const productsArr = [
    'Contact Center', 'Add-ins', 'Crexendo Labs', 'Softphone', 'Bots', 'Cloud Fax'
]

export const FontAwsIcons = {
    create: 'fa-solid fa-plus fa-fw',
    update: 'fa-solid fa-pen fa-fw',
    delete: 'fa-solid fa-trash fa-fw',
    back: 'fa-solid fa-arrow-left-long fa-fw',
    eye: 'fa-solid fa-eye fa-fw',
    collapseOpen: 'fa-solid fa-circle-chevron-up fa-fw',
    collapseClose: 'fa-solid fa-circle-chevron-down fa-fw',
    checkCircle: 'fas fa-check-circle fa-fw',
    crossCircle: 'fas fa-times-circle fa-fw'
}

export const PartnerListGridHeaderNames = {
    name: 'Name',
    shortName: 'Short Name',
    description: 'Description',
    apiEndpoint: 'API Endpoint',
    portalUrl: 'Portal URL',
    regStatus: 'Registration Status',
    accessLevel: 'Access Level',
    action: 'Action'
}

export const AppStatesGridHeaderNames = {
    appName: 'Application Name',
    state: 'State',
    partnerName: 'CSP Name',
    domainName: 'Domain Name',
    tierName: 'Tier Name',
    workflow: 'Workflow',
    updatedOn: 'Updated On',
}

export const EnabledAppsGridHeaderNames = {
    appName: 'Application Name',
    state: 'State',
    partnerName: 'CSP Name',
    domainName: 'Domain Name',
    tierName: 'Tier Name',
    workflow: 'Workflow',
    updatedOn: 'Updated On',
}

export const EnabledCustomerUsersGridHeaderNames = {
    user: 'User',
    name: 'Name',
    scope: 'Scope',
    value: 'Value',
    domainName: 'Domain Name',
}

export const TextEditorButtons = [FONT_SIZE_SELECT, SEPARATOR, BOLD_BUTTON, ITALIC_BUTTON,
    UNDERLINE_BUTTON, SEPARATOR, ORDERED_LIST_BUTTON, UNORDERED_LIST_BUTTON, SEPARATOR,
    INDENT_BUTTON, OUTDENT_BUTTON, SEPARATOR, SUBSCRIPT_BUTTON, SUPERSCRIPT_BUTTON, SEPARATOR,
    UNDO_BUTTON, REDO_BUTTON, REMOVE_FORMAT_BUTTON, SEPARATOR, FORE_COLOR];


export const PaginationPageSizes = [10, 50];

export const GridDomLayouts = {
    normal: 'normal',
    autoHeight: 'autoHeight',
    print: 'print'
}

export const TypingInterval = 800;

export const AllowedTiersCount = 15;

export const agGridTableConfig = {
    sortingOrderDef: ['asc', 'desc', null],
    overlayLoadingTemplate: '<div class="cust-loader cust-loader-abs"><i class="fas fa-spinner fa-spin"></i></div>'
}

export const AppStatesTexts = {
    available: 'AVAILABLE',
    requested: 'REQUESTED',
    processing: 'PROCESSING',
    readytoPublish: 'READY_TO_PUBLISH',
    readytoPublishText: 'READY TO PUBLISH',
    readytoActivate: 'READY_TO_ACTIVATE',
    readytoActivateText: 'READY TO ACTIVATE',
    revoked: 'REVOKED',
    enabled: 'ENABLED',
    preEnabled: 'PRE_ENABLED',
    preEnabledText: 'PRE ENABLED'
}

export const DateFormat = {
    formatA: 'MMM Do YYYY, h:mm a',
    formatB: 'ddd D MMM YYYY (hh:mm A)'
}

export const StorageKeyNamesCommon = {
    auditLogs: 'auditLogs',
    appStates: 'appStates',
    appStatesStatic: 'appStatesStatic',
    wfLogs: 'wfLogs',
    appsList: 'appsList'
}

export const StorageKeyNamesManage = {
    partnerList: 'partnerList',
    vendorList: 'vendorList',
    vendorAppList: 'vendorAppList',
    enabledAppsList: 'enabledAppsList'
}

export const ComponentNames = {
    header: 'header',
    appStoreDefault: 'storeDefault',
    appStoreMain: 'storeMain',
    enabledApps: 'enabledApps',
    availableApps: 'avilableApps',
    allApps: 'allApps',
    appDetails: 'appDetails',
    approvals: 'storeApprovals',
    auditLogs: 'storeAuditLogs'
}

export const SectionNames = {
    main: 'main',
    spotlightIntegration: 'si',
    allApps: 'allApps',
    enabledApps: 'enabledApps',
    availableApps: 'availApps',
    techDetails: 'techDetails',
    customTechDetails: 'customTechDetails',
    partnerWh: 'partnerWh',
    customerWh: 'customerWh',
    userWh: 'userWh',
    partnerWhCf: 'partnerWhCf',
    partnerWhCfUpdate: 'partnerWhCfUpdate',
    customerWhCf: 'customerWhCf',
    customerWhCfUpdate: 'customerWhCfUpdate',
    userWhCf: 'userWhCf',
    userWhCfB: 'userWhCfB'
}

export const ComponentNamesManage = {
    approvals: 'manageApprovals',
    auditLogs: 'manageAuditLogs',
    partners: 'managePartners',
    vendors: 'manageVendors',
    vendorApps: 'manageVendorApps',
    wfLogs: 'manageWfLogs',
}

export const SectionNamesManage = {
    main: 'main',
    partnerWh: 'partnerWh',
    customerWh: 'customerWh',
    userWh: 'userWh',
    partnerWhCf: 'partnerWhCf',
    customerWhCf: 'customerWhCf',
    userWhCf: 'userWhCf',
    enableAppsModal: 'enableAppsModal'
}

export const WebHookTasks = {
    PARTNER_APP_ENABLE: 'PARTNER_APP_ENABLE',
    CUSTOMER_APP_ENABLE: 'CUSTOMER_APP_ENABLE',
    USER_APP_ENABLE: 'USER_APP_ENABLE'
}

export const WebHookType = {
    EXTERNAL_WEBHOOK: 'EXTERNAL_WEBHOOK'
}

export const WebhookFieldTypesList = [
    "text", 'textarea', 'password', 'number', 'email', 'dropdown', 'date', 'checkbox', 'radio'
]

export const AppDetailsActionsForWebhookUpdate = {
    manageDomainsSULogin: 'managedomains',
    enableDomainOMLogin: 'enabledomain',
    manageUsersAtOMLogin: 'manageusers'
}

export const AppsListParams = {
    page: 1,
    per_page: 25,
    per_page_50: 50
}

export const SpotlightAppsCustomOrder = ["CAIRO", "NetSapiens Extend", "CallCabinet", "Iotum", "Textable", "Faxback",
    "TeamMate Technology", "CloudSWEET"
];
